import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectFeeHeadNull {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectFeeHeadNull = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectFeeHeadNull) => {
  const itemList = useStoreState((state) => state.common.feeHeadList);
  const itemListFetch = useStoreActions((state) => state.common.fetchfeeHeadList);
  //const thanaListFetch = useStoreActions((state) => state.common.thanaListFetch);
  
  React.useEffect(()=>{
    itemListFetch();
  },[])
  
  const onSelect = (id) => {
    if (id===undefined){
      onChange(null);
      return;
    }
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }

  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      className="feeSelect"
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      allowClear
      placeholder="Select Fee Head"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Fee Head</Option>
      )}
    </Select>
  );
};
